const styles = (theme) => ({
    dialog: {
        "& .MuiDialog-paperWidthSm": {
            maxWidth: 684,
        },
        "& .MuiDialog-paper": {
            width: 684,
            height: "auto",
        },
        "& .MuiDialogTitle-root": {
            fontFamily: '"Public Sans", sans-serif',
            fontSize: "1.5rem",
            fontStyle: "normal",
            fontWeight: 700,
            color: "rgba(47, 43, 61, 0.9)",
            padding: "32px 32px",
            textAlign: "center",
            "&>div:nth-child(1)": {
                width: "100%",
            },
            "&>div:nth-child(2)": {
                borderBottom: "1px solid rgba(47, 43, 61, 0.12)",
                width: "100%",
                height: "20px",
            },
        },
        "& .MuiDialogContent-root": {
            padding: "0px 40px 32px 40px",
            boxSizing: "border-box",
        },
    },
    subtitle: {
        fontSize: "1.125rem",
        fontWeight: 400,
        fontFamily: '"Public Sans", sans-serif',
        fontStyle: 'normal',
        color: 'rgba(47, 43, 61, 0.9)'
    },
    containerCount: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: "column",
    },
    btnCount: {
        padding: "0.5rem 1rem",
        margin: " 0 5px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer"
    },
    inputCount: {
        textAlign: "center",
        fontSize: "1.5rem",
        backgroundColor: "transparent",
        border: "none",
        width: "100px",
        margin: "5px 0",
    },
    submitButton: {
        height: 38,
        width: "100%",
        background: "#FF844B",
        border: 0,
        boxSizing: "border-box",
        borderRadius: 6,
        boxShadow: "0px 2px 6px rgba(255, 72, 0, 0.24)",
        "& .MuiButton-label": {
            fontFamily: '"Public Sans", sans-serif',
            fontSize: "0.875rem",
            color: "#fff",
            fontWeight: 500,
            textAlign: "center",
            textTransform: "none",
        },
        "&:hover": {
            backgroundColor: "#FF6D00",
        },
    },
    cancelButton: {
        height: 38,
        width: "100%",
        background: "#4E7D96",
        border: 0,
        boxSizing: "border-box",
        borderRadius: 6,
        boxShadow: "0px 2px 6px rgba(78, 125, 150, 0.24)",
        "& .MuiButton-label": {
            fontFamily: '"Public Sans", sans-serif',
            fontSize: "0.875rem",
            color: "#fff",
            fontWeight: 500,
            textAlign: "center",
            textTransform: "none",
        },
        "&:hover": {
            backgroundColor: "#253C47",
        },
    },
});

export default styles;
